import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hkmfzsfinhnvdexltsje.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhrbWZ6c2ZpbmhudmRleGx0c2plIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQxMzg0ODIsImV4cCI6MjA2OTcxNDQ4Mn0.InNvj8oYYzMA-C6Tq4eV8ki_uxBXLJNA4bBnA5IMErI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Optional: Add a global error handler for auth errors
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED') {
    console.log('Token refreshed successfully');
  } else if (event === 'SIGNED_OUT') {
    console.log('User signed out');
  }
});